import co1 from "../assets/co1.jpeg";
import co2 from "../assets/co2.jpeg";
import co3 from "../assets/co3.jpeg";
import co4 from "../assets/co4.jpeg";
import s12 from "../assets/s12.png";

export const CORPORATES_SYLLABUS_DATA = [
 {
    id: "corp-leadership",
    title: "Leadership Training",
    hours: "20 hrs",
    image: co1,
    description:
      "Develop leadership mindset, strategic thinking, and people management skills.",
    modules: [
      "Leadership styles & models",
      "Emotional intelligence",
      "Decision-making & problem-solving",
      "Team building & motivation",
      "Conflict management",
      "Change & crisis leadership",
    ],
    outcomes: [
      "Build confident leaders",
      "Improve team performance",
      "Enhance decision-making ability",
    ],
  },

  {
    id: "corp-softskills",
    title: "Soft Skills Training",
    hours: "25 hrs",
    image: co2,
    description:
      "Enhance communication, professionalism, and workplace effectiveness.",
    modules: [
      "Effective communication",
      "Presentation skills",
      "Time management",
      "Critical thinking",
      "Workplace etiquette",
      "Interview & negotiation skills",
    ],
    outcomes: [
      "Improve professional communication",
      "Boost confidence",
      "Enhance workplace behavior",
    ],
  },

  {
    id: "corp-technical",
    title: "Technical Training",
    hours: "30 hrs",
    image: co3,
    description:
      "Upskill employees with modern technical and digital competencies.",
    modules: [
      "Web technologies overview",
      "Cloud fundamentals",
      "Cybersecurity basics",
      "Data analytics fundamentals",
      "AI & automation basics",
      "Industry-based case studies",
    ],
    outcomes: [
      "Improve technical awareness",
      "Enable digital transformation",
      "Increase productivity",
    ],
  },

  {
    id: "corp-excel-ai",
    title: "Advanced Excel with AI",
    hours: "20 hrs",
    image: co4,
    description:
      "Master Excel with AI-powered tools for data analysis and automation.",
    modules: [
      "Advanced Excel formulas",
      "Pivot tables & dashboards",
      "Power Query",
      "AI-assisted data analysis",
      "Excel automation with AI tools",
      "Real-world business use cases",
    ],
    outcomes: [
      "Analyze data faster",
      "Automate repetitive tasks",
      "Make data-driven decisions",
    ],
  },
   {
    id: "comm-1",
    title: "Communication & Personality Development",
    hours: "30 hrs",
    image: s12,
modules: [
  "Introduction to workplace communication",
  "Product and service communication",
  "Time management and scheduling conversations",
  "Telephone, virtual and remote communication skills",
  "Understanding company structure and operations",
  "Collaboration and teamwork communication",
  "Social and interpersonal workplace communication",
  "Presentation skills and information sharing",
  "Seeking assistance and professional problem-solving",
],
 outcomes: [
  "Communicate confidently in professional and corporate environments",
  "Improve fluency and clarity in workplace English conversations",
  "Handle meetings, calls, and presentations effectively",
  "Strengthen problem-solving and decision-making communication",
  "Build strong professional relationships and networks",
  "Enhance career growth and promotion opportunities",
  "Develop global communication competence for multinational workplaces",
],
idealFor: [
  "Working professionals",
  "Freshers entering corporate roles",
  "Job seekers preparing for interviews",
  "Individuals aiming for career growth",
  "Professionals working in global or client-facing roles",
]
  },
];

